import { Dispatch, useCallback } from 'react';
import { safeMemo } from '../../../../common/util/safeMemo';
import { SpecialtyListItemView, StyledMapMarker } from './SpecialtyFilter.styles';

interface Props {
  onChoose?: Dispatch<string>;
  choice: string;
}

export const SpecialtyListItem = safeMemo(({ choice, onChoose }: Props) => {
  const handleClick = useCallback(() => onChoose?.(choice), [choice, onChoose]);
  return (
    <SpecialtyListItemView onClick={handleClick}>
      <StyledMapMarker />
      <span>{choice}</span>
    </SpecialtyListItemView>
  );
});
